// src/pages/BlogPageData.js
import blogImagePrepare from '../assets/images/blog/blog-prepare-text.png';
import blogImageMtVsHuman from '../assets/images/blog/blog-mt-vs-human.png';
import blogImageMarketingErrors from '../assets/images/blog/blog-marketing-errors.png';
import blogImageLocalizationTips from '../assets/images/blog/blog-localization-tips.png';
import blogImageCatTools from '../assets/images/blog/blog-cat-tools.png';
import blogImageIndustryTrends from '../assets/images/blog/blog-trends-2025.png';

// Plik zawiera tylko dane niezależne od języka
export const blogPostsData = [
  { id: 1, image: blogImagePrepare, date: "2024-05-10", slug: "jak-przygotowac-tekst" },
  { id: 2, image: blogImageMtVsHuman, date: "2024-05-12", slug: "mt-vs-human" },
  { id: 3, image: blogImageMarketingErrors, date: "2024-05-15", slug: "bledy-marketingowe" },
  { id: 4, image: blogImageLocalizationTips, date: "2024-05-18", slug: "lokalizacja-www-wskazowki" },
  { id: 5, image: blogImageCatTools, date: "2024-05-22", slug: "narzedzia-cat" },
  { id: 6, image: blogImageIndustryTrends, date: "2024-05-25", slug: "trendy-tlumaczenia-2025" }
];